(function () {
  var backdrop = document.getElementById('ww-drawer-backdrop');
  var panel = document.getElementById('ww-drawer-panel');
  var itemsEl = document.getElementById('ww-drawer-items');
  var subtotalEl = document.getElementById('ww-drawer-subtotal');
  var closeBtn = document.getElementById('ww-drawer-close');
  var continueLink = document.getElementById('ww-drawer-continue');
  var addonsEl = document.getElementById('ww-drawer-addons');
  if (!backdrop || !panel || !itemsEl) return;

  // Same countdown as the PDP hero — literally, not just visually: same
  // localStorage key (ww_hero_timer, set in ww-hero-buybox.js) and the same
  // duration (read straight off the PDP's own buybox element), so both
  // clocks are deterministically identical to the second instead of two
  // independent timers that could drift apart and look untrustworthy.
  var drawerCountdownEl = document.getElementById('ww-drawer-countdown-time');
  if (drawerCountdownEl) {
    var heroBuyboxRoot = document.querySelector('[id^="ww-buybox-"]');
    var DRAWER_COUNTDOWN_MINUTES = (heroBuyboxRoot && parseInt(heroBuyboxRoot.getAttribute('data-countdown-minutes'), 10)) || 10;
    var DRAWER_DURATION = DRAWER_COUNTDOWN_MINUTES * 60 * 1000;
    var DRAWER_TIMER_KEY = 'ww_hero_timer';
    var drawerStart = parseInt(localStorage.getItem(DRAWER_TIMER_KEY), 10);
    if (!drawerStart || isNaN(drawerStart) || (Date.now() - drawerStart) > DRAWER_DURATION) {
      drawerStart = Date.now();
      localStorage.setItem(DRAWER_TIMER_KEY, drawerStart);
    }
    var padDrawer = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tickDrawer = function () {
      var remaining = DRAWER_DURATION - (Date.now() - drawerStart);
      if (remaining <= 0) {
        drawerStart = Date.now();
        localStorage.setItem(DRAWER_TIMER_KEY, drawerStart);
        remaining = DRAWER_DURATION;
      }
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      drawerCountdownEl.textContent = padDrawer(mins) + ':' + padDrawer(secs);
      setTimeout(tickDrawer, 1000);
    };
    tickDrawer();
  }

  // One-time add-ons (mystery gift, shipping protection, 90-day warranty,
  // priority processing) must never exceed qty 1 per order. They're capped
  // at add-time (checkbox add-on flow / gift auto-add), but once a line is
  // in the cart it renders through the same stepper as any real product —
  // so the "+" button has to be disabled specifically for these variant ids
  // too, or a customer could just click it to stack up extra copies.
  function getCappedVariantIds() {
    var ids = [];
    var collect = function (selector, attr) {
      Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (el) {
        var v = parseInt(el.getAttribute(attr), 10);
        if (v) ids.push(v);
      });
    };
    collect('.ww-drawer-addon-check[data-variant-id]', 'data-variant-id');
    collect('.ww-bump input[type="checkbox"][data-variant-id]', 'data-variant-id');
    collect('[data-gift-variant-id]', 'data-gift-variant-id');
    return ids;
  }
  var CAPPED_VARIANT_IDS = getCappedVariantIds();

  // Add-on checkboxes reflect whichever variants are actually already in the
  // cart (added from here, or anywhere else) — never their own local state.
  function syncAddonCheckboxes(cart) {
    if (!addonsEl) return;
    var cartVariantIds = cart.items.map(function (item) { return item.variant_id; });
    Array.prototype.slice.call(addonsEl.querySelectorAll('.ww-drawer-addon-check')).forEach(function (cb) {
      var vid = parseInt(cb.getAttribute('data-variant-id'), 10);
      cb.checked = cartVariantIds.indexOf(vid) !== -1;
    });
  }

  // Some add-on rows only make sense when a specific product is actually in
  // the cart (e.g. Spare Blower Fan only for the Alien Pick Me Up Costume) —
  // marked with data-requires-product="<handle>" and hidden by default in the
  // Liquid. This is the one place that re-checks that against the live cart,
  // since the drawer never reloads the page after an AJAX add-to-cart.
  function syncConditionalAddons(cart) {
    if (!addonsEl) return;
    var handlesInCart = cart.items.map(function (item) { return item.handle; });
    Array.prototype.slice.call(addonsEl.querySelectorAll('[data-requires-product]')).forEach(function (row) {
      var required = row.getAttribute('data-requires-product');
      var show = handlesInCart.indexOf(required) !== -1;
      row.style.display = show ? 'flex' : 'none';
      if (!show) {
        var cb = row.querySelector('.ww-drawer-addon-check');
        if (cb) cb.checked = false;
      }
    });
    // Opposite of the above: a row that's normally always shown, but should
    // hide specifically when some other product (which already offers this
    // same add-on inline on its own page) is in the cart — e.g. Shipping
    // Protection hides here when the Alien Costume is present, since that
    // product's own page already offers it. Doesn't uncheck/remove an
    // already-added item, just hides the row so it's not offered twice.
    Array.prototype.slice.call(addonsEl.querySelectorAll('[data-hide-for-product]')).forEach(function (row) {
      var hideFor = row.getAttribute('data-hide-for-product');
      var hide = handlesInCart.indexOf(hideFor) !== -1;
      row.style.display = hide ? 'none' : 'flex';
    });
  }

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  function renderItems(cart) {
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="ww-drawer-empty">Your cart is empty.</p>';
      subtotalEl.textContent = formatMoney(0);
      syncAddonCheckboxes(cart);
      syncConditionalAddons(cart);
      return;
    }
    var html = '';
    cart.items.forEach(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      // Deliberately just the final price — no compare/sale split and no
      // per-item "save $X" tag here. The bundle's real per-unit discount math
      // doesn't line up with the PDP's bundle-level compare-at price, and
      // showing both would read as inconsistent/untrustworthy. The PDP is the
      // single source of truth for savings messaging; the drawer just shows
      // what things actually cost.
      var priceHtml = '<span class="ww-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>';
      var isCapped = CAPPED_VARIANT_IDS.indexOf(item.variant_id) !== -1;
      html += '' +
        '<div class="ww-drawer-item" data-line="' + (i + 1) + '">' +
          (img ? '<img class="ww-drawer-item-img" src="' + img + '" alt="" loading="lazy">' : '<div class="ww-drawer-item-img"></div>') +
          '<div class="ww-drawer-item-info">' +
            '<span class="ww-drawer-item-title">' + item.product_title + '</span>' +
            (variant ? '<span class="ww-drawer-item-variant">' + variant + '</span>' : '') +
            '<div class="ww-drawer-item-bottom">' +
              '<div class="ww-drawer-stepper">' +
                '<button type="button" class="ww-drawer-qty-minus" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" class="ww-drawer-qty-plus"' + (isCapped ? ' disabled title="Limited to 1 per order"' : '') + ' aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="ww-drawer-item-price-wrap">' + priceHtml + '</span>' +
            '</div>' +
            '<button type="button" class="ww-drawer-item-remove">Remove</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    subtotalEl.textContent = formatMoney(cart.total_price);
    syncAddonCheckboxes(cart);
    syncConditionalAddons(cart);
  }

  // Every drawer-driven cart mutation (open/refresh, qty +/-, remove) flows through
  // renderItems, so broadcasting from here — rather than from each call site — is
  // the one place that reliably keeps external listeners (e.g. the persistent header/
  // floating cart badges) in sync without them needing their own /cart.js fetch.
  function broadcastCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('ww:cart:updated', { detail: cart }));
  }

  function refresh() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderItems(cart);
        broadcastCartUpdate(cart);
        return cart;
      });
  }

  function open() {
    refresh().then(function () {
      backdrop.classList.add('ww-open');
      panel.classList.add('ww-open');
      panel.setAttribute('aria-hidden', 'false');
      backdrop.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ww-drawer-locked');
    });
  }

  function close() {
    backdrop.classList.remove('ww-open');
    panel.classList.remove('ww-open');
    panel.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ww-drawer-locked');
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderItems(cart);
        broadcastCartUpdate(cart);
        return cart;
      });
  }

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('.ww-drawer-item');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var qtyEl = row.querySelector('.ww-drawer-stepper span');
    var qty = parseInt(qtyEl.textContent, 10);
    if (e.target.classList.contains('ww-drawer-qty-plus')) {
      if (e.target.disabled) return;
      changeLine(line, qty + 1);
    } else if (e.target.classList.contains('ww-drawer-qty-minus')) {
      changeLine(line, Math.max(0, qty - 1));
    } else if (e.target.classList.contains('ww-drawer-item-remove')) {
      changeLine(line, 0);
    }
  });

  if (addonsEl) {
    addonsEl.addEventListener('change', function (e) {
      if (!e.target.classList.contains('ww-drawer-addon-check')) return;
      var checkbox = e.target;
      var vid = parseInt(checkbox.getAttribute('data-variant-id'), 10);
      if (!vid) return;
      checkbox.disabled = true;
      if (checkbox.checked) {
        // Checkbox state is normally synced from the real cart, so re-checking
        // an already-checked box shouldn't be possible in the first place —
        // but confirm against the live cart before adding anyway, so a rapid
        // double-toggle (or anything else that fires this twice) can never
        // add a second copy of the same add-on.
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var alreadyInCart = cart.items.some(function (item) { return item.variant_id === vid; });
            if (alreadyInCart) { checkbox.disabled = false; return; }
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
            })
              .then(refresh)
              .then(function () { checkbox.disabled = false; });
          })
          .catch(function () { checkbox.checked = false; checkbox.disabled = false; });
      } else {
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var line = null;
            cart.items.forEach(function (item, idx) { if (item.variant_id === vid) line = idx + 1; });
            if (!line) { checkbox.disabled = false; return; }
            return changeLine(line, 0).then(function () { checkbox.disabled = false; });
          })
          .catch(function () { checkbox.checked = true; checkbox.disabled = false; });
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  if (continueLink) {
    continueLink.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('ww-open')) close();
  });

  window.WWCartDrawer = { open: open, close: close, refresh: refresh };
})();
